import { configureStore } from "@reduxjs/toolkit";

import vehiculeSlice  from "./vehiculeslice";

const store = configureStore({
    reducer:{
        vehicule:vehiculeSlice
    }
})
export default store;
